import Client from '../HttpClient';

const baseUrl = '/admin/api';
const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const tableMethod = () => {
	return Client.get(`${baseUrl}/profile-table`);
};
const tableMethodCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/profile-table`);
};

const updateTableMethod = (method) => {
	return Client.put(`${baseUrl}/profile-table`, {
		ManuallyEnterTableNumber: !!method,
	});
};

const updateTableMethodCloud = (merchantId, branchId, method) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/profile-table`, {
		ManuallyEnterTableNumber: !!method,
	});
};

const branchProfileInfo = () => {
	return Client.get(`${baseUrl}/profile-branch`);
};
const branchProfileInfoCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/profile-branch`);
};

const updateBranchProfileInfo = (newInfo) => {
	return Client.put(`${baseUrl}/profile-branch`, newInfo);
};
const updateBranchProfileInfoCloud = (merchantId, branchId, newInfo) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/profile-branch`,
		newInfo
	);
};

const getSysParameterListWithType = (type) => {
	return Client.get(`${baseUrl}/parameter/list-type/${type}`);
};

const getSysParameterListWithTypeCloud = (merchantId, branchId, type) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/list-type/${type}`);
};
const batchPutSysParameterList = (value) => {
	return Client.put(`${baseUrl}/parameter/type-batch`, value);
};
const batchPutSysParameterListCloud = (merchantId, branchId, value) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/type-batch`, value);
};
const getDefaultMenuDealList = (value) => {
	return Client.get(`${baseUrl}/defaultmenudeal/list`, value);
};
const getDefaultMenuDealListCloud = (merchantId, branchId, value) => {
	return Client.get(
		`${numbatUrl}/${merchantId}/${branchId}/defaultmenudeal/list`,
		value
	);
};

const updateDefaultMenuDealList = (value) => {
	return Client.put(`${baseUrl}/defaultmenudeal/update`, value);
};
const updateDefaultMenuDealListCloud = (merchantId, branchId, value) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/defaultmenudeal/update`,
		value
	);
};

export default {
	tableMethod,
	updateTableMethod,
	branchProfileInfo,
	updateBranchProfileInfo,
	getSysParameterListWithType,
	batchPutSysParameterList,
	getDefaultMenuDealList,
	updateDefaultMenuDealList,
	tableMethodCloud,
	updateTableMethodCloud,
	branchProfileInfoCloud,
	batchPutSysParameterListCloud,
	updateBranchProfileInfoCloud,
	getSysParameterListWithTypeCloud,
	getDefaultMenuDealListCloud,
	updateDefaultMenuDealListCloud,
};
